var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 21.0286V25.2337H9.2519L21.6539 12.8317L17.4489 8.62663L5.04688 21.0286ZM24.9058 9.57977C25.3431 9.14245 25.3431 8.436 24.9058 7.99868L22.2819 5.37474C21.8445 4.93742 21.1381 4.93742 20.7008 5.37474L18.6487 7.4268L22.8537 11.6318L24.9058 9.57977V9.57977Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.096e6fdbcf9884d75e9a7c4c720e938f.svg";
export { ForwardRef as ReactComponent };